import React from "react";
import { Login } from "./Login";
import ReactDOM from "react-dom";
import { defaultScroll } from "../defaultScroll";
import { containerStyle } from "./indexStyle";
import { is } from "../is";
import { jsBridge } from "../jsBridge";
/**
 * 登录锁定，保证同一时刻只能有一个登录组件弹出
 */
let LOGIN_LOCK = false;
/**
 * 唤起登录车轮账号登录流程
 * 可以自动判断登录环境，如果是车轮客户端，则唤起客户端登录
 *
 * @param result LoginResult
 */
export function login(result) {
    // 登录锁定逻辑判断
    if (LOGIN_LOCK === true) {
        return;
    }
    LOGIN_LOCK = true;
    /**
     * 操作的默认回调
     */
    let onLogin = () => { };
    let onCancel = () => { };
    if (typeof result !== "undefined") {
        if (typeof result.onLogin === "function") {
            onLogin = result.onLogin;
        }
        if (typeof result.onCancel === "function") {
            onCancel = result.onCancel;
        }
    }
    /**
     * 以下APP通过jsBridge登录
     *
     * 1、车轮查违章
     * 2、车轮社区
     * 3、车轮驾考通
     *
     */
    if (is.chaweizhang || is.chelunshequ || is.jiakaotong) {
        jsBridge("app", "login", {
            loginCallBackName(res) {
                if (Number(res.result) === 1) {
                    onLogin(res.data);
                }
                else {
                    onCancel();
                }
            }
        });
        LOGIN_LOCK = false;
        return;
    }
    // 以下开启H5组件登录的流程
    const container = document.createElement("div");
    container.classList.add(containerStyle);
    document.body.appendChild(container);
    // 禁止默认滚动
    defaultScroll.stop();
    const clear = () => {
        // 销毁登录
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
        // 启用默认滚动
        defaultScroll.enable();
        // 解锁登录组件
        LOGIN_LOCK = false;
    };
    ReactDOM.render(React.createElement(Login, { onLogin: (result) => {
            onLogin(result);
            clear();
        }, onCancel: onCancel, onEnd: clear }), container);
}
